import { useState, useEffect, useRef } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const OFFER_SPEND_PAGE_SORT_FIELDS = ['id', 'at', 'amount', 'accountId', 'account.extra.keitaroLogin', 'offerId', 'history.empty'] as const

export type IOfferSpendSortField = typeof OFFER_SPEND_PAGE_SORT_FIELDS[number]

type IUseSortSpendPage = {
	sortBy: IOfferSpendSortField;
	setSortBy: (value: (((prevState: IOfferSpendSortField) => IOfferSpendSortField) | IOfferSpendSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IOfferSpendSortField = 'id'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useOfferSpendSortPage = (buyer: number): IUseSortSpendPage => {
	const isFirstRender = useRef<boolean>(true)
	const [buyerPrev, setBuyerPrev] = useState<number>(buyer)
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return OFFER_SPEND_PAGE_SORT_FIELDS.includes(item[0] as IOfferSpendSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IOfferSpendSortField>(urlSort?.[0]?.[0] as IOfferSpendSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)

	useEffect(() => {
		let _sortBy = sortBy
		let _order = order
		// reset sort logic [RSL] onBuyer (menu tabs) changed
		if (!isFirstRender.current && buyerPrev !== buyer) {
			setBuyerPrev(buyer)
			_sortBy = DEFAULT_SORT_BY
			_order = DEFAULT_SORT_ORDER
			setSortBy(DEFAULT_SORT_BY)
			setOrder(DEFAULT_SORT_ORDER)
		}

		if (_sortBy && _order) {
			const newSortStr = lib.sortSetup([[_sortBy, _order]])

			setSearchParams((prev) => {
				if (!isFirstRender.current) {
					if (_order !== ESortOrder.unset) {
						prev.set('s', newSortStr)
					} else {
						prev.delete('s')
					}
				} else {
					isFirstRender.current = false
				}

				return prev
			})
		}
	}, [buyer, sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}